/**
 * Environment configuration — read from Vite env vars at build time.
 *
 * Type augmentation for ImportMetaEnv lives in `src/vite-env.d.ts`.
 */

const env = import.meta.env as Record<string, string | undefined>;

export const API_URL: string =
  env.VITE_API_URL ?? "https://api.askcarmen.eu";


export function getApiBase(): string {
  return API_URL;
}
